import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function BonusSection() {
  const bonuses = [{
    number: '01',
    label: '🎁 BONO 1',
    title: 'Bases Nutricionales del Desarrollo Muscular',
    desc: 'El complemento nutricional que todo profesional del fitness necesita para responder con criterio. Sin teoría innecesaria. Directo a lo aplicable.',
    price: '$9.990 ARS'
  }, {
    number: '02',
    label: '🎁 BONO 2',
    title: 'La Práctica Profesional del Entrenador Personal',
    desc: 'Las herramientas concretas para ejercer con autoridad. Protocolos, criterios y recursos listos para usar en tu práctica diaria.',
    price: '$9.990 ARS'
  }, {
    number: '03',
    label: '🎁 BONO 3',
    title: 'Caminata del Granjero',
    desc: 'El ejercicio que más se subestima y más beneficios da. Aprendé cómo programarlo para mejorar el grip, la estabilidad escapular y la postura de tus alumnos con un solo movimiento.',
    price: '$9.990 ARS'
  }, {
    number: '04',
    label: '🎁 BONO 4',
    title: 'Kettlebells con Fundamento Técnico',
    desc: 'Todo lo que necesitás saber para programar kettlebell con criterio real: series, repeticiones y ajustes según el objetivo — fuerza, resistencia, hipertrofia o cardio.',
    price: '$9.990 ARS'
  }, {
    number: '05',
    label: '🎁 BONO 5',
    title: 'Arquitectura del Core',
    desc: 'El core no son los abdominales. Descubrí cómo estabilizar, resistir y transferir fuerzas desde el centro del cuerpo, con ejercicios concretos y progresiones aplicables desde la próxima clase.',
    price: '$9.990 ARS'
  }];
  return <section className="py-12 bg-background-dark" data-id="element-36">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-37">
        <FadeIn className="text-center mb-10" data-id="element-38">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white font-heading mb-2" data-id="element-39">
            Más los
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-black text-primary font-heading mb-6" data-id="element-40">
            5 Bonos Estratégicos:
          </h3>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-41">
            Incluidos en todas las opciones — sin costo extra
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-42">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={0.2 + 0.1 * index} direction="up" data-id="element-43">
              <div className="bg-card-dark border border-primary/50 rounded-3xl p-6 md:p-8 h-full flex flex-col relative overflow-hidden group hover:border-primary transition-colors" data-id="element-44">
                <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-2xl group-hover:bg-primary/10 transition-colors" data-id="element-45" />

                <div className="flex items-start justify-between mb-6 relative z-10" data-id="element-46">
                  <span className="text-5xl font-black text-primary/50 font-heading" data-id="element-47">
                    {bonus.number}
                  </span>
                  <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/20" data-id="element-48">
                    <span className="text-xs font-bold text-primary tracking-wider uppercase" data-id="element-49">
                      {bonus.label}
                    </span>
                  </div>
                </div>

                <h4 className="text-2xl font-bold text-white mb-4 relative z-10" data-id="element-50">
                  {bonus.title}
                </h4>

                <p className="text-gray-400 leading-relaxed mb-8 flex-1 relative z-10" data-id="element-51">
                  {bonus.desc}
                </p>

                <div className="flex items-end justify-between mt-auto relative z-10" data-id="element-52">
                  <span className="text-gray-500 line-through font-medium notranslate" translate="no" data-id="element-53">
                    {bonus.price}
                  </span>
                  <span className="bg-primary text-black font-black px-4 py-2 rounded-lg text-lg tracking-wide" data-id="element-54">
                    GRATIS
                  </span>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-55">
          <div className="bg-card-dark border border-gray-800 rounded-2xl p-8 text-center max-w-2xl mx-auto shadow-2xl" data-id="element-56">
            <p className="text-gray-400 mb-2" data-id="element-57">Valor total de los 5 bonos:</p>
            <p className="text-3xl md:text-4xl font-bold text-gray-500 line-through mb-4 decoration-red-500 decoration-4" data-id="element-58">
              $49.950
            </p>
            <p className="text-white font-bold text-xl mb-2" data-id="element-59">
              Hoy te los llevás por:
            </p>
            <p className="text-6xl md:text-7xl font-black text-green-500 mb-6 drop-shadow-[0_0_15px_rgba(34,197,94,0.3)]" data-id="element-60">
              $0
            </p>
            <p className="text-yellow-500 font-bold text-sm md:text-base tracking-wide" data-id="element-61">
              ✨ Incluidos GRATIS con tu compra de hoy ✨
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}